export const Messages = {
  currentVersion: 'Current version',
  tooltip: 'The date the currently running version was compiled',
};
